import { formatearFecha, formatearMXN } from '@eg/compartido'
import { es } from '../../content/es'
import type { TipoCambio } from './datos'

/** Aclara cómo se pasaron a pesos los precios fijados en dólares. No muestra nada si todo está en pesos. */
export function NotaTipoCambio({ tipoCambio }: { tipoCambio: TipoCambio | null | undefined }) {
  if (!tipoCambio) return null
  return <p className="campo__ayuda nota-cambio">{es.tipoCambio(formatearMXN(tipoCambio.usdMxn), formatearFecha(tipoCambio.fecha))}</p>
}
